// ローディング

const ROOT = document.documentElement;

// 最低限見せる時間
const MIN_TIME = 1200;
// 強制的に開ける時間
const MAX_TIME = 8000;
// 開き始めてから出現演出までの時間
const REVEAL_DELAY = 600;

const tasks = new Set(["htmx", "side", "fonts"]);
const total = tasks.size;
const startedAt = performance.now();
let finished = false;
// 出現演出を始めてよいか
let ready = !ROOT.classList.contains("is-loading");

const setProgress = () => {
	const value = (total - tasks.size) / total;
	ROOT.style.setProperty("--progress", String(value));
};

const finish = () => {
	if (finished) return;
	finished = true;
	ROOT.style.setProperty("--progress", "1");

	const wait = Math.max(0, MIN_TIME - (performance.now() - startedAt));
	setTimeout(() => {
		ROOT.classList.remove("is-loading");
		ROOT.classList.add("is-loaded");
		setTimeout(() => {
			ready = true;
			window.dispatchEvent(new Event("site:loaded"));
		}, REVEAL_DELAY);
	}, wait);
};

/**
 * 待ち合わせの1つが終わった
 * @param {"htmx"|"side"|"fonts"} name
 */
export const done = (name) => {
	if (!tasks.delete(name)) return;
	setProgress();
	if (tasks.size === 0) finish();
};

/**
 * 画像の読み込みを待つ（失敗しても先へ進む）
 * @param {HTMLImageElement} img
 * @returns {Promise<void>}
 */
function waitImage(img) {
	return new Promise((resolve) => {
		if (img.complete) {
			resolve();
			return;
		}
		img.addEventListener("load", () => resolve(), { once: true });
		img.addEventListener("error", () => resolve(), { once: true });
	});
}

/**
 * 左面の読み込みを待つ
 */
export const waitSide = () => {
	const side = document.querySelector(".side");
	const imgs = side ? [side.querySelector(".side-logo img"), side.querySelector(".slide img")].filter(Boolean) : [];
	Promise.all(imgs.map(waitImage)).then(() => done("side"));
};

/**
 * @returns {boolean} 出現演出を待たせるか
 */
export const isLoading = () => !ready;

export const initLoading = () => {
	if (ready) return;

	setProgress();

	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(() => done("fonts"));
	} else {
		done("fonts");
	}

	// 左面が無いページでは待たない
	if (!document.querySelector(".side")) done("side");

	setTimeout(finish, MAX_TIME);
};

export default initLoading;
